
import { supabase } from '@/lib/supabase';

export interface ClassStaffAssignment {
  id: string;
  class_id: string;
  staff_id: string;
  organization_id: string;
  assigned_at: string;
  staff_member?: {
    id: string;
    first_name: string;
    last_name: string;
    email?: string | null;
    profile_photo_url?: string | null;
    role?: string;
  };
  class?: {
    id: string;
    name: string;
  };
}

export const StaffAssignmentService = {
  // Get all staff assignments for a class, including basic staff info
  async getAssignmentsByClass(classId: string): Promise<ClassStaffAssignment[]> {
    const { data, error } = await supabase
      .from('class_staff_assignments')
      .select('*, staff_member:staff_id(id, first_name, last_name, email, profile_photo_url, role)')
      .eq('class_id', classId);

    if (error) {
      console.error('Error fetching class staff assignments:', error);
      return [];
    }
    return data as ClassStaffAssignment[];
  },

  // Get all class assignments for a staff member, including basic class info
  async getAssignmentsByStaff(staffId: string): Promise<ClassStaffAssignment[]> {
    const { data, error } = await supabase
      .from('class_staff_assignments')
      .select('*, class:class_id(id, name)')
      .eq('staff_id', staffId);

    if (error) {
      console.error('Error fetching staff class assignments:', error);
      return [];
    }
    return data as ClassStaffAssignment[];
  },

  // Assign a staff member to this class
  async assignStaffToClass(classId: string, staffId: string, organizationId: string): Promise<void> {
    const { error } = await supabase
      .from('class_staff_assignments')
      .insert([{ class_id: classId, staff_id: staffId, organization_id: organizationId }]);
    if (error) throw error;
  },

  // Unassign a staff member from this class
  async unassignStaffFromClass(classId: string, staffId: string): Promise<void> {
    const { error } = await supabase
      .from('class_staff_assignments')
      .delete()
      .eq('class_id', classId)
      .eq('staff_id', staffId);

    if (error) throw error;
  }
};
